export default __webpack_public_path__ + "static/media/de.1708c5f7.svg";